<app-competition-item [title]="'Competition Details'">
  <div class="content ml-4 mr-4 mb-2 pb-4">
    <div class="row">
      <div class="col-12 mb-1">
        <span class="title">Topic Name*</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input inputFocus class="form-control border-0" type="text" [(ngModel)]="competition.displayName"
          [attr.placeholder]="'Topic Name'" [disabled]="disabled" required>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-1">
        <span class="title">Competition URL*</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input inputFocus class="form-control border-0" type="text" [(ngModel)]="competition.compUrl" (change)="urlChanged()"
               [attr.placeholder]="'Leave empty to autogenerate'" [disabled]="disabled" required>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-1">
        <span class="title">Is competition public</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input inputFocus class="form-control border-0" type="checkbox" [(ngModel)]="competition.is_public"
               [attr.placeholder]="'Is competition public'" [disabled]="disabled" required>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-1">
        <span class="title">Hide UPTOP logo</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input inputFocus class="form-control border-0" type="checkbox" [(ngModel)]="competition.hide_uptop_logo"
               [attr.placeholder]="'Hide UPTOP logo'" [disabled]="disabled">
      </div>
    </div>
  </div>
</app-competition-item>
